import React from 'react';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';
import {EvenOddListItemContentFactoryProps} from '../../../../../shared/components/evenOddList';
import {maskPrivateData} from '../../../../../shared/pipes/maskPrivateData';
import {PhoneChangeField} from '../../../common/phoneChangeField';
import {EmailChangeField} from '../../../common/emailChangeField';
import View from './view';

export const ProfileUserContacts: React.FC = () => {
  const styles = useStyles(({theme}) => {
    return {
      prop: {
        ...theme.fonts.body,
        textAlign: 'right',
        maxWidth: '60%',
        color: theme.color.textColor,
        opacity: 1,
      },
      label: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.labelText,
        maxWidth: '38%',
      },
      text: {
        color: theme.color.textColor,
      },
    };
  });

  const profile = useSelector(holderProfileSelector());
  if (!profile) return null;

  const addresses = [
    {
      value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
        <>
          <Text style={styles.label}>Проживания</Text>
          <Text style={[styles.prop, styles.text]}>
            {isMasked ? maskPrivateData(profile.address) : profile.address}
          </Text>
        </>
      ),
    },
  ];

  const phone = [
    {
      value: <PhoneChangeField isMasked onDisableMasking={() => undefined} />,
    },
  ];

  const email = [
    {
      value: <EmailChangeField isMasked onDisableMasking={() => undefined} />,
    },
  ];

  return <View addresses={addresses} phone={phone} email={email} profile={profile} />;
};
